<template>
  <div class="OnboardingView container flex flex-col md-pt-56">
    <div class="mb-24 grid col-1 lg-col-2 pb-40">
      <div class="OnboardingView__left lg-pr-112">
        <template v-if="productionTip">
          <div>
            <img
              v-if="productionTip.Image"
              class="w-full hide md-d-block"
              :src="`${productionTip.Image.data.attributes.url}`"
              alt=""
            />
            <div class="hide lg-d-block">
              <h2 class="font-family-display font-weight-bold mb-24">
                {{ productionTip.Title }}
              </h2>
              <p>{{ productionTip.Text }}</p>
            </div>
          </div>
        </template>
      </div>
      <div class="OnboardingView__right pt-0">
        <template v-if="isLastStep">
          <StepperWidget :steps="steps" @step="commonStore.setActiveStep" />
        </template>

        <router-view v-slot="{ Component }">
          <keep-alive>
            <component :is="Component" @set-step="commonStore.setActiveStep" />
          </keep-alive>
        </router-view>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import StepperWidget from '@/components/StepperWidget.vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from '@/stores/commonStore'
import { useCmsStore } from '@/stores/cmsStore'
import { useRoute } from 'vue-router'

const commonStore = useCommonStore()
const cmsStore = useCmsStore()
const route = useRoute()

const { steps } = storeToRefs(commonStore)
const { productionTip } = storeToRefs(cmsStore)

const isLastStep = computed(() => route.name === 'OnboardingFinishView')
</script>

<style lang="scss" scoped>
.OnboardingView {
  margin-top: 0;
  margin-bottom: 0;
}
</style>
